//Can possibly be removed
// export const universalPrimers = [
//   { label: "3 AD" },
//   { label: "3 AOX1" },
//   { label: "3 DNA-BD" },
//   { label: "5 AD" },
//   { label: "5 AOX1" },
//   { label: "21TA" },
//   { label: "21TC" },
//   { label: "21TG" },
//   { label: "1012F" },
//   { label: "1012R" },
//   { label: "ACYCDuetUP1" },
//   { label: "BGH Reverse" },
//   { label: "BK REVERSE" },
//   { label: "CMV Forward" },
//   { label: "DuetDOWN1" },
//   { label: "DuetUP2" },
//   { label: "EF-1a Forward" },
//   { label: "EGFP- C" },
//   { label: "EGFP- N" },
//   { label: "GEX 3" },
//   { label: "GEX 3B" },
//   { label: "GEX 5" },
//   { label: "GL Primer 1" },
//   { label: "GL Primer 2" },
//   { label: "KS" },
//   { label: "LKO1-5" },
//   { label: "M13F(-20)" },
//   { label: "M13F(-40)	" },
//   { label: "M13R" },
//   { label: "mCherry-F" },
//   { label: "mCherry-R" },
//   { label: "myc-HIS Revers" },
//   { label: "pBAD Forward" },
//   { label: "pBAD Reverse" },
//   { label: "pCMV-Forward" },
//   { label: "pET Upstream Primer" },
//   { label: "pFastBacForward" },
//   { label: "pFastBac Reverse" },
//   { label: "pGEX3" },
//   { label: "pGEX5" },
//   { label: "pREP Forward" },
//   { label: "pRSET Reverse" },
//   { label: "pTrcHis Forward" },
//   { label: "pTrcHis Reverse" },
//   { label: "pTRE 3" },
//   { label: "pTRE2-3" },
//   { label: "pTRE5" },
//   { label: "QE Promoter" },
//   { label: "QE Reverse" },
//   { label: "RV Primer 3" },
//   { label: "RV Primer 4" },
//   { label: "SK" },
//   { label: "SP6" },
//   { label: "SP6 Promoter" },
//   { label: "T3" },
//   { label: "T7" },
//   { label: "T7EEV" },
//   { label: "T7 Reverse" },
//   { label: "T7 Term" },
//   { label: "U19" },
//   { label: "V1.5" },
//   { label: "XL39" },
// ];

export const universalPrimers = [
  { label: "3AD" },
  { label: "3AOX1" },
  { label: "3DNA-BD" },
  { label: "5AD" },
  { label: "5AOX1" },
  { label: "21TA" },
  { label: "21TC" },
  { label: "21TG" },
  { label: "1012F" },
  { label: "1012R" },
  { label: "ACYCDuetUP1" },
  { label: "BGHReverse" },
  { label: "BKREVERSE" },
  { label: "CMVForward" },
  { label: "DuetDOWN1" },
  { label: "DuetUP2" },
  { label: "EF-1aForward" },
  { label: "EGFP-C" },
  { label: "EGFP-N" },
  { label: "GEX3" },
  { label: "GEX3B" },
  { label: "GEX5" },
  { label: "GLPrimer1" },
  { label: "GLPrimer2" },
  { label: "KS" },
  { label: "LKO1-5" },
  { label: "M13F(-20)" },
  { label: "M13F(-40)" },
  { label: "M13R" },
  { label: "mCherry-F" },
  { label: "mCherry-R" },
  { label: "myc-HISRevers" },
  { label: "pBADForward" },
  { label: "pBADReverse" },
  { label: "pCMV-Forward" },
  { label: "pETUpstreamPrimer" },
  { label: "pFastBacForward" },
  { label: "pFastBacReverse" },
  { label: "pGEX3" },
  { label: "pGEX5" },
  { label: "pREPForward" },
  { label: "pRSETReverse" },
  { label: "pTrcHisForward" },
  { label: "pTrcHisReverse" },
  { label: "pTRE3" },
  { label: "pTRE2-3" },
  { label: "pTRE5" },
  { label: "QEPromoter" },
  { label: "QEReverse" },
  { label: "RVPrimer3" },
  { label: "RVPrimer4" },
  { label: "SK" },
  { label: "SP6" },
  { label: "SP6Promoter" },
  { label: "T3" },
  { label: "T7" },
  { label: "T7EEV" },
  { label: "T7Reverse" },
  { label: "T7Term" },
  { label: "U19" },
  { label: "V1.5" },
  { label: "XL39" },
];